var React = require('react');

function MailInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"none","fillRule":"evenodd","stroke":"#ffffff","strokeLinejoin":"round","strokeWidth":"2","transform":"translate(10 20)"},[React.createElement("polyline",{"points":"0 0 30 27.4 60 0","key":0}),React.createElement("polygon",{"points":"0 0 60 0 60 40 0 40","key":1})]));
}

MailInline.defaultProps = {"width":"80","height":"80","viewBox":"0 0 80 80"};

module.exports = MailInline;

MailInline.default = MailInline;
